import {
  List,
  Pagination,
  Datagrid,
  TextField,
  DateField,
  FunctionField,
  usePermissions
} from "react-admin";
import { Box } from "@mui/material";
import DetailsButton from "../../components/buttons/details-button";
import EditCustomerPassportPhysicalButton from "../../components/buttons/edit-customer-passport-physical-button";
import DeletePassportPhysicalButton from "../../components/buttons/delete-customer-passport-physical-button";
import FilterCustomerPassportPhysicalMaster from "../../ra/list/filters/customer-passport-physical-master";
import FilterCustomerPassportPhysical from "../../ra/list/filters/customer-passport-physical";
import Actions from "../../ra/list/actions";
import CustomerPassportPhysicalExporter from "../../exporter/customer-passport-physical-exporter";

const CustomerPassportPhysicalList = () =>
{
  const { permissions } = usePermissions();

  return (
    <List
      title="Entregas de Passaporte Físico"
      perPage={10}
      sort={{ field: "id", order: "DESC" }}
      filters={(permissions && permissions.is_master === true) ? FilterCustomerPassportPhysicalMaster : FilterCustomerPassportPhysical}
      exporter={CustomerPassportPhysicalExporter}
      pagination={<Pagination rowsPerPageOptions={[10, 25, 50, 100, 150, 200]} />}
      actions={<Actions sx={{ gap: 1.5 }} />}>
      <Datagrid
        rowClick={false}
        bulkActionButtons={false}>
        <TextField source="id" sortBy="id" />
        <TextField source="customer_passport" label="Número Passaporte" sortable={false} />
        <TextField source="customer_name" label="Usuário" sortable={false} />
        <TextField source="collection_point_passport_name" label="Retirado Em" sortable={false} />
        <TextField source="collection_point_passport_admin_name" label="Entregue Por" sortable={false} />
        <DateField source="date_withdrawal" locales="pt-BR" label="Data Retirada" showTime sortable={false} />
        <DateField source="created_at" locales="pt-BR" label="Criado Em" showTime sortBy="created_at" />
        <FunctionField
          label="Ações"
          sortable={false}
          render={() => (
            <Box
              sx={{
                display: "grid",
                gridAutoFlow: "column",
                gap: 1.5,
                width: "max-content",
                alignItems: "center",
              }}>
              <DetailsButton />
              <EditCustomerPassportPhysicalButton />
              <DeletePassportPhysicalButton />
            </Box>
          )}
        />
      </Datagrid>
    </List>
  );
};

export default CustomerPassportPhysicalList;
